const DEBUG = false;
const debugPrint = (...print ) => {
    if(DEBUG) {
        console.log(...print)
    }
} 

// header link hover states
// ----
    
// array of anchors used on the page, in the order they appear
const headerIDs = [
    'header',
    'reach',
    'certification',
    'landscape',
    'engagement',
    'finances'
]

// now we use that to generate our other information
const headerLinks = headerIDs.map(anchor => document.querySelector(`a[href='#${anchor}']`))

const updateHeaderColors = () => {
    const sectionOffsets = headerIDs.map(id => document.getElementById(id).offsetTop)

    debugPrint('saved', sectionOffsets)
    debugPrint('calc', headerIDs.map(id => document.getElementById(id).offsetTop));
    
    // first we find the index off the scroll offset we're on
    let offsetIndex = sectionOffsets.findIndex((offset, index, array) => {
        const nextOffset = array[index + 1];
        // adjust our scroll y postiotn to match the css scroll-offset we've set
        const scrollY = window.scrollY + 46

        // if we're on the last item, we know we need that one, so return now
        if (!nextOffset) {
            return true
        }
        //console.table({index: headerIDs[index], offset:  offset, scroll: scrollY, nextoffset: nextOffset})
        return offset <= scrollY && scrollY < nextOffset;
    })

    // then we reset all selected classes
    headerLinks.forEach(link => {
        if(link) {
            link.classList.remove('selected')
        }
    })

    // finally we use our earlier calculated index to select the appropriate
    // link in the header and add the selected class
    currentLink = headerLinks[offsetIndex];
    if (currentLink) {
        (currentLink.classList.add('selected'))
    }
} 

document.addEventListener('scroll', updateHeaderColors)
document.onload = updateHeaderColors;
